/* eslint-disable react-refresh/only-export-components */
import React from "react";
import GuestLayout from "@/layouts/guest-layout";

import CostEstimator from "@/pages/cost-estimator";
import CostEstimatorResult from "@/pages/cost-estimator-results";
import ErrorPage from "@/pages/Error";
import GuestAppLoader from "@/layouts/guest-app-loader";
import RequireAuth from "@/pages/containers/require-auth";
const SpendSummary = React.lazy(() => import("@/pages/spend-summary"));
import validateToken from "@/services/validator";
// Removed the import for GuestLayout due to the error
import { createBrowserRouter, Outlet, redirect } from "react-router-dom";
import RequireGroup from "@/pages/containers/require-group";

import ScreenRouteNames from "@/constants/screen-route-names";
import Home from "@/pages/home";
import NotificationPage from "@/pages/notification";
import CareHistory from "@/pages/care-history";
import IDCard from "@/pages/id-card";
import Biometrics from "@/pages/biometrics";
import MyBenefit from "@/pages/my-benefit";
import ProviderSearch from "@/pages/provider-search";
import ProviderSearchResult from "@/pages/provider-search-result";
import MyAccount from "@/pages/components/my-account/editAccount-enable";
import Service from "@/pages/services";
import AccessDeniedPage from "@/pages/error/access-denied";
import SessionExpiredPage from "@/pages/error/session-expired";
import Error404 from "@/pages/error/404";
import { STORAGE_KEY } from "@/constants";
import { AuthMode } from "@/context/auth-provider";
import BalanceBill from "@/pages/balance-bill";
import { lowerCaseComparison } from "@/lib/string-util";
import { useRouteLogger } from "@/services/logger/logger-hooks";
import { ChatNotAvailable } from "@/pages/components/csr-chat/ChatNotAvailable";
import Survey from "@/pages/survey";
import { HcbbCostEstimatorSearchPage } from "@/pages/hcbb-cost-estimator/hcbb-cost-estimator-search";
import { HcbbCostEstimatorResultPage } from "@/pages/hcbb-cost-estimator/hcbb-cost-estimator-result";
import { HcbbFacilityDetailPage } from "@/pages/hcbb-cost-estimator/hcbb-facility-detail";
import { HcbbProviderDetailPage } from "@/pages/hcbb-cost-estimator/hcbb-provider-detail";
import Videos from "@/pages/videos";

const AppLayout = () => {
  useRouteLogger();
  return <Outlet />;
};
// provider-search-pt
const router = createBrowserRouter(
  [
    {
      // path: "/",
      element: <AppLayout />,
      children: [
        {
          path: "/guest-login",
          element: <GuestAppLoader />,
          loader: validateToken,
        },
        {
          // path: "/provider-search-pt",
          element: (
            <RequireGroup>
              <RequireAuth>
                <GuestLayout />
              </RequireAuth>
            </RequireGroup>
          ),
          loader: ({ request }) => {
            const sessionUserData = JSON.parse(
              window.sessionStorage.getItem(STORAGE_KEY.AUTH_DATA) || "{}",
            );

            // console.log("1139: route guest", sessionUserData);

            if (lowerCaseComparison(sessionUserData?.mode, AuthMode.MEMBER))
              return null;
            const url = new URL(request.url);
            // console.log("TestRoute:-> Guest Layout loader", { url: request.url, pathname: url.pathname, sessionUserData });
            if (Boolean(sessionUserData) === false) {
              // console.log("TestRoute:-> case 1");
              return null;
            } else {
              // console.log("1139: TestRoute:-> case 2");
              if (sessionUserData?.user?.route === ScreenRouteNames.HOME.path) {
                // console.log("TestRoute:-> case 2.1");
                return null;
              } else if (
                sessionUserData?.user?.route !== ScreenRouteNames.HOME.path &&
                url.pathname.includes(sessionUserData?.user?.route)
              ) {
                // console.log("TestRoute:-> case 2.2", url.pathname, sessionUserData?.user?.route, url.pathname.includes(sessionUserData?.user?.route));
                return null;
              } else {
                // console.log("TestRoute:-> case 2.3", url.pathname, sessionUserData?.user?.route, url.pathname.includes(sessionUserData?.user?.route));
                return redirect(`/${ScreenRouteNames.ACCESS_DENIED.path}`);
              }
            }
          },
          children: [
            {
              index: true,
              path: ScreenRouteNames.HOME.path,
              element: <Home />,
            },
            {
              path: ScreenRouteNames.NOTIFICATION.path,
              element: <NotificationPage />,
            },
            {
              path: ScreenRouteNames.CARE_HISTORY.path,
              element: <CareHistory />,
            },
            {
              path: ScreenRouteNames.ID_CARD.path,
              element: <IDCard />,
            },
            {
              path: ScreenRouteNames.BIOMETRICS.path,
              element: <Biometrics />,
            },

            {
              path: ScreenRouteNames.MY_ACCOUNT.path,
              element: <MyAccount />,
            },

            {
              path: ScreenRouteNames.MY_BENEFIT.path,
              element: <MyBenefit />,
            },

            {
              path: ScreenRouteNames.SPEND_SUMMARY.path,
              element: <SpendSummary />,
            },

            {
              path: ScreenRouteNames.SERVICE.path,
              element: <Service />,
            },
            {
              path: ScreenRouteNames.PROVIDER_SEARCH_BY_GROUP.path,
              element: <ProviderSearch />,
            },
            {
              path: `${ScreenRouteNames.PROVIDER_SEARCH_BY_GROUP.path}/${ScreenRouteNames.PROVIDER_SEARCH_RESULT.path}`,
              element: <ProviderSearchResult />,
            },
            {
              path: ScreenRouteNames.COST_ESTIMATOR.path,
              element: <CostEstimator />,
              // children: [
              //   {
              //     path: ScreeRouteNames.COST_ESTIMATOR_RESULT,
              //     element: <CostEstimatorResult />,
              //   },
              // ],
            },
            {
              path: ScreenRouteNames.HCBB_COST_ESTIMATOR.path,
              element: <HcbbCostEstimatorSearchPage />,
            },
            {
              path: `${ScreenRouteNames.HCBB_COST_ESTIMATOR.path}/${ScreenRouteNames.HCBB_COST_ESTIMATOR_RESULT.path}`,
              element: <HcbbCostEstimatorResultPage />,
            },
            {
              path: `${ScreenRouteNames.HCBB_COST_ESTIMATOR.path}/${ScreenRouteNames.HCBB_COST_ESTIMATOR_RESULT.path}/${ScreenRouteNames.HCBB_FACILITY_DETAIL.path}`,
              element: <HcbbFacilityDetailPage />,
            },
            {
              path: `${ScreenRouteNames.HCBB_COST_ESTIMATOR.path}/${ScreenRouteNames.HCBB_COST_ESTIMATOR_RESULT.path}/${ScreenRouteNames.HCBB_PROVIDER_DETAIL.path}`,
              element: <HcbbProviderDetailPage />,
            },
            {
              path: `${ScreenRouteNames.COST_ESTIMATOR.path}/${ScreenRouteNames.COST_ESTIMATOR_RESULT.path}`,
              element: <CostEstimatorResult />,
            },
            {
              path: `${ScreenRouteNames.SURVEY.path}`,
              element: <Survey />,
            },
            {
              path: `${ScreenRouteNames.BALANCE_BILL.path}`,
              element: <BalanceBill />,
            },
            {
              path: `${ScreenRouteNames.CSR_CHAT.path}`,
              element: <ChatNotAvailable />,
            },
            {
              path: `${ScreenRouteNames.VIDEOS.path}`,
              element: <Videos />,
            },
          ],
        },
      ],
      errorElement: <ErrorPage />,
    },
    {
      path: "*",
      element: <Error404 />,
    },
    {
      path: ScreenRouteNames.ERROR.path,
      element: <ErrorPage />,
    },
    {
      path: ScreenRouteNames.ACCESS_DENIED.path,
      element: <AccessDeniedPage />,
    },
    {
      path: ScreenRouteNames.SESSION_EXPIRED.path,
      element: <SessionExpiredPage />,
    },
  ],
  { hydrateFallbackElement: null },
);

/**
 * in the context of your React Router configuration, the path: "/" within the nested route structure has a specific role. Let's break down the difference between using it and commenting it out:
Using path: "/"
When you specify path: "/" in a nested route, it means that this route will match the root path of the parent route. In your case, the parent route is also "/", so this nested route will match the root path of your application. The GuestLayout component will be rendered at the root path, and its children will be rendered based on their respective paths.
Commenting path: "/"
If you comment out path: "/", the nested route will not have a specific path to match. This means that the GuestLayout component will not be rendered at the root path. Instead, the router will look for other routes that match the root path or any other specified paths.
 */
export default router;
